import styled from 'styled-components';

import { WHITE, BLACK, PAGE_WIDTH, BG_GRAY } from '../../../styles/variables.style';
import media from '../../../styles/media.style';

export const Section = styled.section`
  max-width: ${PAGE_WIDTH}px;
  width: 100%;
  margin: 0 auto 4em;
  overflow: hidden;

  ${media.tabletL`
    margin-bottom: 90px;
  `};
`;

export const Title = styled.h5`
  position: relative;
  text-transform: uppercase;
  margin: 0;
  padding-bottom: 60px;
  background-color: ${WHITE};
  letter-spacing: 0.1em;
  text-align: center;
  color: ${BLACK};

  &::after {
    content: '';
    position: absolute;
    bottom: 35px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BLACK};
    height: 3px;
    width: 40px;
  }

  ${media.tabletL`
    padding-bottom: 115px;
    &::after {
      bottom: 80px;
    }
  `};
`;

export const SliderWrapper = styled.div`
  margin-bottom: 60px;
`;

export const InstructorCell = styled.div`
  background-color: ${BG_GRAY.COMMON_1};

  ${media.tabletL`
    display: flex;
  `};
`;

export const Name = styled.p`
  margin: 0;
  text-transform: uppercase;
  font-size: 30px;
  letter-spacing: 1px;
`;

export const ImageWrapper = styled.div`
  ${media.tabletL`
    width: 50%;
  `};
`;
export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 370px;
  margin: 65px auto 0;

  ${media.tabletL`
    margin-top: 0;
  `};
`;
export const Description = styled.p`
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/pages/SeminarPage/InstructorSlider/InstructorSlider.style.js